import { ExternalLoginProviderType } from './ExternalLoginProviderType';

export type ModalType = {
  isOpen: boolean,
  data: ExternalLoginProviderType | null
}

export const emptyModalType : ModalType = { isOpen: false, data: null }